module.exports = __webpack_public_path__ + "img/gold.d14eec43.png";